import React from 'react';
import {
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaCopyright
} from 'react-icons/fa';
import logo from '../../assets/images/logo.png';
import './Footer.css';

function Footer() {
  const googleMapsStandardEmbed = "https://www.google.com/maps?q=No%2020%2F2%20Jayamaha%20Vihara%20Road%2C%20Matara%2081000&output=embed";
  const googleMapsDirectLink = "https://maps.app.goo.gl/McrscB3MuyEaojfv9";

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo + Map */}
        <div className="footer-logo-section">
          <img src={logo} alt="Kasiwaththa Associates Logo" className="footer-logo" />
          <p className="footer-slogan">Your trusted engineering partner since 1999</p>
          
          {/* Map Section - Choose one of the options below */}
          
          {/* Option A: Standard Embed (Try this first) */}
          <div className="footer-map-inline">
            <iframe
              src={googleMapsStandardEmbed}
              width="100%"
              height="180"
              style={{ border: 0, borderRadius: '8px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Kasiwaththa Associates Location - Matara"
            ></iframe>
          </div>

          {/* Option B: With API Key (Uncomment and add your API key)
          <div className="footer-map-inline">
            <iframe
              src={googleMapsEmbedUrl}
              width="100%"
              height="180"
              style={{ border: 0, borderRadius: '8px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Kasiwaththa Associates Location - Matara"
            ></iframe>
          </div>
          */}

          {/* Option C: Fallback Link (Uncomment if iframe doesn't work)
          <div className="footer-map-inline">
            <div className="map-placeholder">
              <a 
                href={googleMapsDirectLink}
                target="_blank" 
                rel="noopener noreferrer"
                className="map-link"
              >
                <FaMapMarkerAlt className="map-icon" />
                <span>View Location on Google Maps</span>
              </a>
            </div>
          </div>
          */}
        </div>

        {/* Contact */}
        <div className="footer-contact">
          <h3>Contact Us</h3>
          <ul className="contact-list">
            <li className="contact-item">
              <FaMapMarkerAlt className="contact-icon" />
              <address>
                No 20/2,<br />
                Jayamaha Vihara Road,<br />
                Matara 81000
                <br />
                <a
                  href={googleMapsDirectLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="map-link"
                >
                  Open in Google Maps
                </a>
              </address>
            </li>
            <li className="contact-item">
              <FaPhone className="contact-icon" />
              <div className="phone-numbers">
                <a href="tel:+94412224713" aria-label="Call office number">+94 41 2224713</a>
                <a href="tel:+94773454333" aria-label="Call mobile number">+94 77 3454333</a>
              </div>
            </li>
            
            <li className="contact-item">
              <FaEnvelope className="contact-icon" />
              <div className="emails">
                <a href="mailto:kasiwaththaassociates@gmail.com" aria-label="Send email to main address">
                  kasiwaththaassociates@gmail.com
                </a>
                <a href="mailto:ruwankasiwatta@ymail.com" aria-label="Send email to secondary address">
                  ruwankasiwatta@ymail.com
                </a>
              </div>
            </li>
          </ul>
        </div>

        {/* Services */}
        <div className="footer-services">
          <h3>Our Services</h3>
          <ul className="services-list">
            <li>House Plans</li>
            <li>Architechtural Designs</li>
            <li>3D Designs</li>
            <li>Structural Designs</li>
            <li>Valuation Reports</li>
            <li>Building Construction</li>
            <li>Site Supervision</li>
            <li>Engineering Consultancy</li>
            <li>Interior & Landscape Design Solutions</li>
            <li>Website Development</li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="copyright">
          <FaCopyright /> 2026 All Rights Reserved. | Designed by{' '}
          <a 
            href="tel:+94722239529"
            aria-label="Call Kasiwaththa Associates IT Solutions"
            className="copyright-whatsapp-link"
          >
            Kasiwaththa Associates IT Solutions
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;